var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconQrWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.29541 5.30005V13.177H13.1911V5.30005H5.29541ZM10.5304 10.5485H7.91293V7.93719H10.5304V10.5485Z",
    fill: "#FFFFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8691 5.30005V13.177H23.7562V5.30005H15.8691ZM21.0955 10.5485H18.4867V7.93719H21.0955V10.5485Z",
    fill: "#FFFFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.29541 15.823V23.7H13.1911V15.823H5.29541ZM10.5304 21.0801H7.91293V18.4688H10.5304V21.0801Z",
    fill: "#FFFFFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4953 21.0972H15.8433V23.7403H18.4953V21.0972Z",
    fill: "#FFFFFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4868 18.46V21.0713H21.1216V23.7343H23.7564V21.0713V20.0371V18.46H18.4868Z",
    fill: "#FFFFFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5212 15.8574H15.8691V18.5006H18.5212V15.8574Z",
    fill: "#FFFFFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.02811 0H0.034668V7.9373H2.57444V2.61991H1.02811V0Z",
    fill: "#FFFFFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9047 0H2.57464H1.02832V2.61991H2.57464H7.9047V0Z",
    fill: "#FFFFFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 27.9657V28.9568H7.95621V26.4231H2.62616V27.9657H0Z",
    fill: "#FFFFFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0 21.0972V26.4232V27.9658H2.62615V26.4232V21.0972H0Z",
    fill: "#FFFFFF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9721 0.0344238H28.9655V7.97172H26.4258V2.65433H27.9721V0.0344238Z",
    fill: "#FFFFFF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0957 0.0344238H26.4258H27.9721V2.65433H26.4258H21.0957V0.0344238Z",
    fill: "#FFFFFF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0002 28.0003V29H21.0439V26.4663H26.374V28.0003H29.0002Z",
    fill: "#FFFFFF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0002 21.1404V26.4664V28.0004H26.374V26.4664V21.1404H29.0002Z",
    fill: "#FFFFFF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQrWhite);
export default __webpack_public_path__ + "static/media/icon-qr-white.11c3e8dea10371ff380d5a66855074bd.svg";
export { ForwardRef as ReactComponent };